import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { EbookPreview } from '../components/EbookPreview';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-407">
      <OfferBanner data-id="element-408" />
      <main data-id="element-409">
        <HeroSection data-id="element-410" />
        <EmotionalConnection data-id="element-411" />
        <AvatarPains data-id="element-412" />
        <SolutionBenefits data-id="element-413" />
        <BreedGallery data-id="element-414" />
        <EbookPreview data-id="element-415" />
        <ProductOffer data-id="element-416" />
        <Bonuses data-id="element-417" />
        <Testimonials data-id="element-418" />
        <FAQ data-id="element-419" />
      </main>
      <Footer data-id="element-420" />
      <FloatingCTA data-id="element-421" />
    </div>;
}